import { getLocalizedString } from "common/components/localization";
import { Appearance } from "common/generator/components/button-appearance";
import { WireButton } from "webapp/ui/views/wire-button/wire-button";
import type { BaseProps } from "../custom-sign-in-props";
import { ButtonWrapper, ContentContainer, Input, Subtitle, Title } from "./custom-wire-sign-in-style";

interface Props extends BaseProps {}

const WireNameInputImpl: React.FunctionComponent<Props> = p => {
    const { greeting, description, colorTheme, onPressedContinue, canContinue, username, onUsernameChange, appKind } =
        p;

    return (
        <>
            <ContentContainer>
                <div>
                    <Title data-test="app-sign-in-title">{greeting}</Title>
                    <Subtitle id="sign-in-description" data-test="app-sign-in-subtitle">
                        {description}
                    </Subtitle>
                    <Input
                        data-test="app-name-input"
                        value={username}
                        onChange={e => onUsernameChange(e.target.value)}
                        type="text"
                        inputMode="text"
                        placeholder={getLocalizedString("name", appKind)}
                        colorTheme={colorTheme}
                        autoFocus={true}
                    />
                </div>
            </ContentContainer>
            <ButtonWrapper colorTheme={colorTheme} showFooter={false}>
                <WireButton
                    onClick={onPressedContinue}
                    disabled={canContinue === false}
                    appearance={Appearance.Filled}
                    size={"md"}
                    tw="w-full">
                    {getLocalizedString("continue", appKind)}
                </WireButton>
            </ButtonWrapper>
        </>
    );
};

const WireNameInput = WireNameInputImpl;
export default WireNameInput;
